// Components
import LoginHeader from "../../components/login/header";
import LoginForm from "../../components/login/form";
import EodyneLogo from "../../components/login/eodyneLogo";

const SignIn = () => (
  <>
    <LoginHeader />
    <LoginForm />
    <EodyneLogo />
  </>
);

export default SignIn;
